import React from 'react'
import { Button, Col, Form, Media } from 'reactstrap';
import { ConfigServer } from '../../data/config';
import { Dialog } from 'primereact/dialog';



export const ModalAuthorizationCash = (props) => {

    const {
        toogleAuthorization,
        modalAuthorization,
        _commercialLine,
        _nameUser,
        _branchName,
        _new,
        handleOpenPreview,
        handleClosedPreview,
        viewDetail,
        viewAmount,
        formatter,
        user,
        _admin_cash,
        id_cash,
        saveCourtesyPatient,
        listPayMethod,

    } = props;



    return (
        <Dialog
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">
                        <div className="Global-dialog-icon">
                            <i className="pi pi-check-circle"></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                Autorización de cortes

                            </div>
                        </div>
                    </div>
                </div>
            }


            className="Global-dialog Global-blue Global-medium2"
            maskClassName="custom-total-mask"


            closable={false}

            visible={modalAuthorization}
            onHide={toogleAuthorization}
            modal

            footer={
                <>

                    {
                        _admin_cash !== "True" && <>
                            <Button color='secondary' onClick={toogleAuthorization}>Aceptar</Button>
                        </>
                    }
                    {
                        _admin_cash === "True" && <>
                            <Button color='danger' onClick={toogleAuthorization}>Cancelar</Button>
                            <Button color='secondary' onClick={() => saveCourtesyPatient(_new, id_cash)}>Autorizar</Button>
                        </>
                    }
                </>
            }
        >

            <Col
                sm="12"
                className="cash-authorization-container "
            >
                <Form
                    className="cash-authorization-form"
                    role="form"
                >
                    {_admin_cash === "True" ? (
                        <div className="cash-authorization-content">

                            <div className="cash-authorization-company-card">
                                <div className="cash-authorization-company-icon">
                                    <i className="fa fa-building-o"></i>
                                </div>

                                <div className="cash-authorization-company-information">
                                    <span className="cash-authorization-section-label">
                                        REVISIÓN CONTABLE
                                    </span>

                                    <h5 className="cash-authorization-company-name">
                                        {_commercialLine ?? "Sin línea comercial"}
                                    </h5>

                                    <span className="cash-authorization-branch-name">
                                        {_branchName ?? "Sin sucursal"}
                                    </span>
                                </div>

                                <div className="cash-authorization-company-logo">
                                    <img
                                        src={
                                            ConfigServer.serverUrl +
                                            "/api/Configuration/Logo"
                                        }
                                        alt="Logo"
                                    />
                                </div>
                            </div>

                            <div className="cash-authorization-alert">
                                <div className="cash-authorization-alert-icon">
                                    <i className="fa fa-exclamation-triangle"></i>
                                </div>

                                <div className="cash-authorization-alert-content">
                                    <span className="cash-authorization-alert-title">
                                        Corte pendiente de autorización
                                    </span>

                                    <span className="cash-authorization-alert-description">
                                        Verifica la información entregada por el responsable
                                        antes de autorizar el corte.
                                    </span>
                                </div>

                                <button
                                    type="button"
                                    className="cash-authorization-detail-button"
                                    onClick={
                                        viewDetail
                                            ? handleClosedPreview
                                            : handleOpenPreview
                                    }
                                >
                                    <i
                                        className={
                                            viewDetail
                                                ? "fa fa-eye-slash"
                                                : "fa fa-eye"
                                        }
                                    ></i>

                                    {viewDetail ? "Ocultar detalle" : "Ver detalle"}
                                </button>
                            </div>

                            {viewDetail && (
                                <div className="cash-authorization-detail-grid">
                                    <div className="cash-authorization-card">
                                        <div className="cash-authorization-card-header">
                                            <div className="cash-authorization-card-header-icon cash-authorization-card-header-icon-blue">
                                                <i className="fa fa-user"></i>
                                            </div>

                                            <div>
                                                <h6 className="cash-authorization-card-title">
                                                    Responsable del corte
                                                </h6>

                                                <span className="cash-authorization-card-subtitle">
                                                    Usuario que registró y entregó el corte
                                                </span>
                                            </div>

                                            <span className="cash-authorization-level cash-authorization-level-blue">
                                                Responsable
                                            </span>
                                        </div>

                                        <div className="cash-authorization-user">
                                            <div className="cash-authorization-user-avatar">
                                                <Media
                                                    src={require("../../assets/images/loginHelenLabs/User/UserWoman.svg")}
                                                    alt="Responsable del corte"
                                                />
                                            </div>

                                            <div className="cash-authorization-user-information">
                                                <span className="cash-authorization-user-label">
                                                    Usuario responsable
                                                </span>

                                                <span className="cash-authorization-user-name">
                                                    {user ?? "Usuario no disponible"}
                                                </span>
                                            </div>

                                            <div className="cash-authorization-user-status">
                                                <i className="fa fa-check-circle"></i>
                                                Registrado
                                            </div>
                                        </div>
                                    </div>

                                    {/* MÉTODOS DE PAGO */}
                                    <div className="cash-authorization-card">
                                        <div className="cash-authorization-card-header">
                                            <div className="cash-authorization-card-header-icon cash-authorization-card-header-icon-green">
                                                <i className="fa fa-credit-card"></i>
                                            </div>

                                            <div>
                                                <h6 className="cash-authorization-card-title">
                                                    Métodos de pago
                                                </h6>

                                                <span className="cash-authorization-card-subtitle">
                                                    Importes registrados en el corte
                                                </span>
                                            </div>

                                            <span className="cash-authorization-level cash-authorization-level-green">
                                                {viewAmount?.length ?? 0} métodos
                                            </span>
                                        </div>

                                        <div className="cash-authorization-payment-list">
                                            {viewAmount?.length > 0 ? (
                                                viewAmount.map((_pay, _k) => {

                                                    const payMethod = listPayMethod?.find(
                                                        x => x.id_pay_method === _pay?.id_pay_method
                                                    );

                                                    const payMethodLabel = payMethod?.name ?? "Método desconocido";

                                                    let payMethodIcon = "fa-question-circle";

                                                    switch (_pay?.id_pay_method) {
                                                        case 1:
                                                            payMethodIcon = "fa-money";
                                                            break;

                                                        case 2:
                                                            payMethodIcon = "fa-credit-card";
                                                            break;

                                                        case 4:
                                                            payMethodIcon = "fa-credit-card-alt";
                                                            break;

                                                        case 7:
                                                            payMethodIcon = "fa-money";
                                                            break;

                                                        case 8:
                                                            payMethodIcon = "fa-exchange";
                                                            break;

                                                        case 10:
                                                            payMethodIcon = "fa-calendar-check-o";
                                                            break;

                                                        case 28:
                                                            payMethodIcon = "fa-university";
                                                            break;

                                                        case 29:
                                                            payMethodIcon = "fa-id-card";
                                                            break;

                                                        case 30:
                                                            payMethodIcon = "fa-ticket";
                                                            break;

                                                        default:
                                                            payMethodIcon = "fa-question-circle";
                                                            break;
                                                    }

                                                    return (
                                                        <div
                                                            className="cash-authorization-payment-item"
                                                            key={_pay?.id_pay_method ?? _k}
                                                        >
                                                            <div className="cash-authorization-payment-information">
                                                                <span className="cash-authorization-payment-icon">
                                                                    <i className={`fa ${payMethodIcon}`}></i>
                                                                </span>

                                                                <span className="cash-authorization-payment-name">
                                                                    {payMethodLabel}
                                                                </span>
                                                            </div>

                                                            <span className="cash-authorization-payment-amount">
                                                                {formatter.format(
                                                                    Number(_pay?.amount ?? 0)
                                                                )}
                                                            </span>
                                                        </div>
                                                    );
                                                })
                                            ) : (
                                                <div className="cash-authorization-empty">
                                                    <i className="fa fa-info-circle"></i>
                                                    No existen métodos de pago registrados.
                                                </div>
                                            )}
                                        </div>

                                        <div className="cash-authorization-total">
                                            <div className="cash-authorization-total-information">
                                                <span className="cash-authorization-total-label">
                                                    Total de efectivo registrado
                                                </span>

                                                <span className="cash-authorization-total-description">
                                                    Suma de todos los métodos de pago
                                                </span>
                                            </div>

                                            <span className="cash-authorization-total-amount">
                                                {formatter.format(
                                                    (viewAmount ?? []).reduce(
                                                        (total, payment) =>
                                                            total +
                                                            Number(payment?.amount ?? 0),
                                                        0
                                                    )
                                                )}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div className="cash-authorization-authorization-card">
                                <div className="cash-authorization-authorization-header">
                                    <div className="cash-authorization-authorization-icon">
                                        <i className="fa fa-check-square-o"></i>
                                    </div>

                                    <div>
                                        <h6 className="cash-authorization-authorization-title">
                                            Información de autorización
                                        </h6>

                                        <span className="cash-authorization-authorization-subtitle">
                                            Datos del usuario que autoriza el corte
                                        </span>
                                    </div>
                                </div>

                                <div className="cash-authorization-authorization-grid">

                                    <div className="cash-authorization-information-item">
                                        <div className="cash-authorization-information-number">
                                            1
                                        </div>

                                        <div className="cash-authorization-information-content">
                                            <span className="cash-authorization-information-label">
                                                Fecha y hora de autorización
                                            </span>

                                            <span className="cash-authorization-information-value">
                                                {_new ?? "Pendiente de autorización"}
                                            </span>
                                        </div>

                                        <span className="cash-authorization-information-tag cash-authorization-information-tag-blue">
                                            <i className="fa fa-calendar"></i>                                        </span>
                                    </div>

                                    <div className="cash-authorization-information-item">
                                        <div className="cash-authorization-information-number cash-authorization-information-number-green">
                                            2
                                        </div>

                                        <div className="cash-authorization-information-content">
                                            <span className="cash-authorization-information-label">
                                                Responsable de autorizar
                                            </span>

                                            <span className="cash-authorization-information-value">
                                                {_nameUser ?? "Usuario no disponible"}
                                            </span>
                                        </div>

                                        <span className="cash-authorization-information-tag cash-authorization-information-tag-green">
                                            <i className="fa fa-check-circle"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="cash-authorization-access-denied">
                            <div className="cash-authorization-access-image">
                                <img
                                    src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                    alt="Acceso restringido"
                                />
                            </div>

                            <div className="cash-authorization-access-icon">
                                <i className="fa fa-lock"></i>
                            </div>

                            <h5 className="cash-authorization-access-title">
                                Autorización requerida
                            </h5>

                            <p className="cash-authorization-access-description">
                                No cuentas con permisos para autorizar cortes. Contacta al
                                área de Administración.
                            </p>
                        </div>
                    )}
                </Form>
            </Col>
        </Dialog>

    )
}
